export enum SmsNotificationType {
  Sms = 'Sms',
  Whatsapp = 'Whatsapp'
}
